//
//  EditDependant Actions
//  CXA Apollo
//
//  Created on 09/01/2017.
//  Copyright (c) 2017 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//

import api from "../api/flexapi";
import moment from "moment";

// Type of action being performed
export const SET_DEPENDANT_ID = "SET_DEPENDANT_ID";
export const LOAD_DEPENDANT_FIELDS_BEGIN = "LOAD_DEPENDANT_FIELDS_BEGIN";
export const LOAD_DEPENDANT_FIELDS_SUCCESS = "LOAD_DEPENDANT_FIELDS_SUCCESS";
export const LOAD_DEPENDANT_FIELDS_FAILED = "LOAD_DEPENDANT_FIELDS_FAILED";
export const LOAD_DEPENDANT_BEGIN = "LOAD_DEPENDANT_BEGIN";
export const LOAD_DEPENDANT_SUCCESS = "LOAD_DEPENDANT_SUCCESS";
export const LOAD_DEPENDANT_FAILED = "LOAD_DEPENDANT_FAILED";
export const SET_EDIT_DEPENDANT_FORM_LOADED = "SET_EDIT_DEPENDANT_FORM_LOADED";
export const SAVE_DEPENDANT_BEGIN = "SAVE_DEPENDANT_BEGIN";
export const SAVE_DEPENDANT_SUCCESS = "SAVE_DEPENDANT_SUCCESS";
export const SAVE_DEPENDANT_FAIL = "SAVE_DEPENDANT_FAIL";
export const RESET_DEPENDANT_FORM = "RESET_DEPENDANT_FORM";

export function setDependantId(dependantId, employeeKey) {
  return { type: SET_DEPENDANT_ID, payload: { dependantId, employeeKey } };
}

export function setEditDependantFormLoaded() {
  return { type: SET_EDIT_DEPENDANT_FORM_LOADED, payload: null };
}

export function resetEditDependantForm() {
  return { type: RESET_DEPENDANT_FORM, payload: null };
}

// api call to load dependant data
export function loadDependant(dependantId) {
  return dispatch => {
    dispatch({ type: LOAD_DEPENDANT_BEGIN, payload: { dependantId } });

    return api
      .getUserProfile()
      .then(response => {
        dispatch({
          type: LOAD_DEPENDANT_SUCCESS,
          meta: { dependantId },
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: LOAD_DEPENDANT_FAILED,
          meta: { dependantId },
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

// api call to load dependant fields data
export function loadDependantFields() {
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: LOAD_DEPENDANT_FIELDS_BEGIN, payload: null });

    api
      .getDependantFields()
      .then(response => {
        dispatch({
          type: LOAD_DEPENDANT_FIELDS_SUCCESS,
          payload: response.body,
        });
      })
      .catch(err => {
        dispatch({
          type: LOAD_DEPENDANT_FIELDS_FAILED,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}

// The action to be called from AddEditDependantForm.
// it loads all necessary data and is the control flow of all.
export function loadDependantFormData(dependantId, employeeKey) {
  return dispatch => {
    dispatch(setDependantId(dependantId, employeeKey));

    const apiCalls = dependantId
      ? [dispatch(loadDependantFields()), dispatch(loadDependant(dependantId))]
      : [dispatch(loadDependantFields())];

    return dispatch(() => Promise.all(apiCalls)).then(() => {
      dispatch(setEditDependantFormLoaded());
    });
  };
}

const normalizeValue = (field, value) => value;

const getPostData = (fields, values, dependant, dependantId, employeeKey) => {
  const fieldsToPost = dependantId == 0
    ? fields // On adding, submit all fields' values
    : fields.filter(f => !f.disabled); // On editing, submit only not diabled fields' values. This is required by API.

  return {
    employeeKey,
    dependantKey: dependantId ? dependantId : 0,
    data: fieldsToPost.map(f => ({
      id: f.id,
      value: normalizeValue(f, values[f.id]),
    })),
  };
};

export function saveDependant(data) {
  return (dispatch, getState) => {
    dispatch({ type: SAVE_DEPENDANT_BEGIN, payload: null });

    const {
      dependants: { fields, dependant, dependantId, employeeKey },
    } = getState();
    const postData = getPostData(
      fields,
      data,
      dependant,
      dependantId,
      employeeKey
    );

    const saveAction = postData.dependantKey > 0
      ? api.updateDependant(postData)
      : api.addDependant(postData);

    return saveAction
      .then(response => {
        dispatch({ type: SAVE_DEPENDANT_SUCCESS, payload: response.body });
      })
      .catch(err => {
        dispatch({
          type: SAVE_DEPENDANT_FAIL,
          payload: err.response ? err.response.body : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/dependantActions.js